import { createActionCreator } from 'deox';

export const updateSiteOverviewDocActions = {
  updateSiteOverviewDoc: createActionCreator(
    'UPDATE_SITE_OVERVIEW_DOC_REQUEST',
    (resolve) => (html: string) => resolve({ html }),
  ),
};
